import { render, staticRenderFns } from "./chooseMerchant.vue?vue&type=template&id=b131216a&scoped=true"
import script from "./chooseMerchant.vue?vue&type=script&lang=js"
export * from "./chooseMerchant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b131216a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\tx_projects\\plat-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b131216a')) {
      api.createRecord('b131216a', component.options)
    } else {
      api.reload('b131216a', component.options)
    }
    module.hot.accept("./chooseMerchant.vue?vue&type=template&id=b131216a&scoped=true", function () {
      api.rerender('b131216a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/systemSetting/baseConfig/costConfig/chooseMerchant.vue"
export default component.exports